'use client'

import clsx from 'clsx'
import Link from 'next/link'
import { FC } from 'react'

import { ExpandableItems } from '@/shared/ui'

import { useSeoLinks } from '../hooks/useSeoLink'

import cls from './seo-links.module.scss'

type SeoLinksProps = {
	className?: string
	place: 'top' | 'bottom'
	title?: string
}

export const SeoLinks: FC<SeoLinksProps> = props => {
	const { className, place, title } = props
	const { seoLinks } = useSeoLinks(place)

	if (!seoLinks?.length) return null

	return (
		<section className={clsx(cls.root, className)}>
			{title && <p className={cls.title}>{title}</p>}
			<ExpandableItems
				visibleRows={{
					mobile: 1
				}}
				className={cls.group}
				toggleClassName={cls.toggle}
				expandLabel="Показать все">
				{seoLinks.map(item => (
					<Link className={cls.link} key={item.LINK} href={item.LINK} prefetch={false}>
						{item.NAME}
					</Link>
				))}
			</ExpandableItems>
		</section>
	)
}
